import { AxiosHeaders } from 'axios';
export class RestClientError extends Error {
    constructor(axiosError) {
        super(axiosError.message);
        this.axiosError = axiosError;
        this.name = 'RestClientError';
        Object.setPrototypeOf(this, RestClientError.prototype);
    }
    get code() {
        return this.axiosError.code;
    }
    get request() {
        return this.axiosError.request;
    }
    get message() {
        return this.axiosError.message;
    }
    get status() {
        return this.axiosError.status;
    }
    get response() {
        const axiosResponse = this.axiosError.response;
        if (!axiosResponse) {
            return;
        }
        return {
            data: axiosResponse.data,
            status: axiosResponse.status,
            statusText: axiosResponse.statusText,
            headers: (axiosResponse.headers instanceof AxiosHeaders
                ? axiosResponse.headers.toJSON()
                : axiosResponse.headers),
        };
    }
}
